export class InsuranceInformationResponse {
    constructor(apiResponse) {
        this._apiResponse = apiResponse["contenido"];
        this._applicant_name = this._apiResponse['objeto']['nombre_solicitante'];
    }

    applicant_name() {
        return this._applicant_name
    }
}